import { OEAsset, useClient } from "@adamlip/okeoke.client"
import { Card, CardBody, CardFooter } from "@nextui-org/react"
import { useNavigate } from "react-router-dom"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext } from "react"
import { isDesktop } from "react-device-detect"

function CategoryCard({ category, categories, layout, showImage }) {
  const { getName } = useClient()
  const { appParams } = useContext(AppParamsContext)
  const navigate = useNavigate()

  const handleAddClick = () => {
    console.log(
      "navigate to ",
      category?.uuid,
      `/order?categoryUUID=${category?.uuid}`
    )
    navigate(`/order?categoryUUID=${category?.uuid}`)
  }

  const currentCategory = Object?.values(categories)?.find(
    (cat) => cat?.uuid === category?.uuid
  )
  return (
    <Card
      onClick={() => handleAddClick()}
      style={{
        border:
          "var(--button-border-width) solid var(--startNav-category-border-color)",
      }}
      key={category?.uuid}
      shadow="sm"
      isPressable
      className={`${
        layout === "list" || isDesktop ? "w-[150px]" : "w-[45%]"
      } h-full bg-[var(--startNav-category-bg-color)] text-[var(--startNav-category-text-color)]  rounded-[var(--general-border-radius)]`}
    >
      {showImage && (
        <CardBody className="overflow-visible p-0">
          <div className="aspect-ratio">
            <OEAsset
              uuid={currentCategory?.attributes.appImage}
              addClass={`orderItemListItem-img ${
                appParams?.features?.imagesContain
                  ? "img-contain"
                  : "w-full object-cover h-full"
              }`}
              size="l"
            />
          </div>
        </CardBody>
      )}
      <CardFooter className="text-small justify-between flex flex-col full relative text-[var(--startNav-category-text-color)]">
        <p
          className={`text-md w-full text-left truncate ${
            appParams?.styles?.fonts?.capitalize
              ? "font-extrabold uppercase"
              : ""
          }`}
        >
          {getName(currentCategory?.name)}
        </p>
      </CardFooter>
    </Card>
  )
}

export default CategoryCard
